var _path, _path2, _path3;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgZoomOut = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M11.157 16.242c3.041 0 5.506-2.383 5.506-5.323 0-2.94-2.465-5.322-5.506-5.322-3.04 0-5.505 2.383-5.505 5.322 0 2.94 2.465 5.323 5.505 5.323Zm0 1.597c3.953 0 7.158-3.098 7.158-6.92C18.315 7.098 15.11 4 11.157 4 7.204 4 4 7.098 4 10.92c0 3.82 3.204 6.919 7.157 6.919Z",
  fill: "currentColor"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M16.146 15.145 20 18.871 18.832 20l-3.854-3.726 1.168-1.129Z",
  fill: "currentColor"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M7.303 10.387h7.708v1.597H7.303v-1.597Z",
  fill: "currentColor"
})));

export default SvgZoomOut;